<template>
  <router-view />
</template>

<script>
export default {
  name: "LandSuitability",
};
</script>
